"use client";

import { Warning } from "@monsterindia/global-ui-components";
import React from "react";

export const UnsubscribeWarning: React.FC = () => {
  return (
    <div className="mb-5 flex items-center justify-center gap-3 rounded-[8px] border border-[#ECC475] bg-[#FFF6E5] px-3 py-3 md:mb-6 md:px-6">
      <Warning className="h-5 w-[22px] flex-shrink-0 text-[#8F5800]" />
      <div>
        <span className="text-[14px] font-bold leading-[20px] text-[var(--Decorative-Content-04,#8F5800)]">
          Important:{" "}
        </span>
        <span className="text-sm font-normal leading-5 text-[#8F5800]">
          Unsubscribing may stop you from receiving your best job matches.
        </span>
      </div>
    </div>
  );
};
